import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    displayFlex: { display: 'flex', alignItems: 'center', marginLeft: 8 },
    title: {
      fontSize: 12,
      color: palette.grey700,
      fontWeight: 500,
      margin: 4,
      width: '100%',
      justifyContent: 'space-between',
      display: 'flex',
      cursor: 'pointer',
    },
    titleSelected: {
      fontSize: 12,
      color: palette.green,
      fontWeight: 500,
      margin: 4,
      width: '100%',
      justifyContent: 'space-between',
      display: 'flex',
      cursor: 'pointer',
    },
    titleConfig: { cursor: 'default' },
    label: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: 100,
      margin: 0,
    },
    labelSmall: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: 60,
      margin: 0,
    },
    filterIcon: { fontSize: 16, color: palette.blue, marginLeft: 4 },
    filterIconGreen: { fontSize: 16, color: palette.green, marginLeft: 4 },
  });
